module.exports = __webpack_public_path__ + "img/archives.c5ff8a59.svg";